import React from "react";
import { toast } from "react-toastify";
import http from "../utils/http-common";
function Pricing() {
  const styles = {
    page: {
      fontFamily: "Inter, Arial, sans-serif",
      color: "#333",
      maxWidth: 1200,
      margin: "0 auto",
      padding: "24px 16px",
    },
    header: {
      textAlign: "center",
      marginBottom: 24,
    },
    title: {
      fontSize: 28,
      fontWeight: 700,
      margin: 0,
    },
    subtitle: {
      fontSize: 16,
      color: "#666",
      marginTop: 8,
    },
    cards: {
      display: "flex",
      gap: 24,
      alignItems: "stretch",
      justifyContent: "center",
      flexWrap: "nowrap",
      overflowX: "auto",
      paddingBottom: 8,
    },
    card: {
      border: "1px solid #0a0a0aff",
      borderRadius: 16,
      padding: 20,
      boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      flex: "0 0 250px",
      minWidth: 250
    },
    planHeader: {
      textAlign: "center",
      marginBottom: 12,
    },
    planDesc: {
      fontSize: 12,
      color: "#6b7280",
      textAlign: "center",
    },
    planName: {
      fontSize: 18,
      fontWeight: 700,
      color: "#0a7f2a",
      marginBottom: 10,
    },
    price: {
      fontSize: 28,
      fontWeight: 800,
      color: "#0a7f2a",
      margin: "12px 0",
    },
    oldPrice: {
      fontSize: 20,
      color: "#6b7280",
      textDecoration: "line-through",
      marginRight: 8,
    },
    betaNote: {
      fontSize: 12,
      color: "#6b7280",
      textAlign: "center",
    },
    features: {
      listStyle: "none",
      padding: 0,
      margin: "12px 0",
      display: "grid",
      gap: 8,
    },
    feature: {
      display: "flex",
      alignItems: "center",
      gap: 8,
      fontSize: 14,
    },
    check: { color: "#0a7f2a", fontWeight: 700 },
    cross: { color: "#dc2626", fontWeight: 700 },
    cta: {
      display: "flex",
      justifyContent: "center",
      marginTop: 6,
      paddingBottom: 6,
    },
    btn: {
      border: "none",
      borderRadius: 9999,
      padding: "10px 18px",
      cursor: "pointer",
      fontWeight: 600,
    },
    btnFree: { backgroundColor: "#22c55e", color: "white" },
    btnPremium: { backgroundColor: "#6d28d9", color: "white" },
    btnBusiness: { backgroundColor: "#f97316", color: "white" },
    premiumCard: {
      backgroundColor: "#f0fdf4", // subtle green highlight
      borderColor: "#86efac",
    },
  };
const user_id = localStorage.getItem("user_id");
  const handlePlanChoice = async (planName) => {

                try {
                  const response = await http.post(`/auth_service/permimum_request/mail`, {
                    "user_id": user_id,
                    "action": planName
                  });
                  toast.success(`Thanks for choosing ${planName}. We will get back to you.`);
                } catch (error) {
                  console.error("Error fetching view data", error);
                }
    
  };

  return (
    <div style={styles.page}>
      <div style={styles.header}>
        <h1 style={styles.title}>Plans That Work as Hard as You Do</h1>
        <p style={styles.subtitle}>
          Whether you're just getting started or running a full-scale project, we've got the perfect plan for you.
        </p>
      </div>

      <div style={styles.cards}>
        {/* Free Forever */}
        <div style={styles.card}>
          <div>
            <div style={styles.planHeader}>
              <div style={styles.planName}>Free Forever</div>
              <div style={styles.planDesc}>Dipping your toes in the water? Get started with all the essentials—our viewer and team sharing tools are yours forever, for free. No strings attached (we promise).</div>
              <div style={styles.price}>FREE</div>
            <div style={styles.cta}>
              <button
              style={{
      borderRadius: 9999,
      padding: "10px 18px",
      cursor: "not-allowed",
      fontWeight: 600,
      opacity: 0.5,
      pointerEvents: "none",
      backgroundColor: "#ccc", }}
            >
              You are here
            </button>
            </div>
            </div>
            <ul style={styles.features}>
              <li style={styles.feature}><span style={styles.check}>✓</span>Viewer</li>
              <li style={styles.feature}><span style={styles.check}>✓</span>Team Sharing</li>
              <li style={styles.feature}><span style={styles.check}>✓</span>Max Projects: 1</li>
              <li style={styles.feature}><span style={styles.check}>✓</span>Max Users: 5</li>
              <li style={styles.feature}><span style={styles.check}>✓</span>Mobile App for team</li>
              <li style={styles.feature}><span style={styles.cross}>✗</span>Schedule Analysis</li>
              <li style={styles.feature}><span style={styles.cross}>✗</span>Templates Library</li>
            </ul>
          </div>
        </div>

        {/* Premium */}
        <div style={{ ...styles.card, ...styles.premiumCard }}>
          <div>
            <div style={styles.planHeader}>
              <div style={styles.planName}>Premium</div>
              <div style={styles.planDesc}>For the multitaskers and overachievers. Run up to 10 projects, share with 100 users, and unlock powerful tools like schedule analysis and templates. Because your time is priceless.</div>
          
              <div>
                <span style={styles.oldPrice}>$9.99</span>
                <span style={styles.price}>$0.00</span>
              </div>
              <div style={styles.betaNote}>**FREE DURING BETA**</div>
            </div>
          <div style={styles.cta}>
            <button
              style={{ ...styles.btn, ...styles.btnPremium }}
              onClick={() => handlePlanChoice("Go Premium")}
            >
              Go Premium
            </button>
          </div>
              <div style={styles.betaNote}>billed per person per month</div>
            <ul style={styles.features}>
              <li style={styles.feature}><span style={styles.check}>✓</span>Viewer</li>
              <li style={styles.feature}><span style={styles.check}>✓</span>Team Sharing</li>
              <li style={styles.feature}><span style={styles.check}>✓</span>Max Projects: 10</li>
              <li style={styles.feature}><span style={styles.check}>✓</span>Max Users: 100</li>
              <li style={styles.feature}><span style={styles.check}>✓</span>Schedule Analysis reports</li>
              <li style={styles.feature}><span style={styles.check}>✓</span>Templates Library</li>
            </ul>
          </div>

        </div>

        {/* Business */}
        <div style={styles.card}>
          <div>
            <div style={styles.planHeader}>
              <div style={styles.planName}>Business</div>
              <div style={styles.planDesc}>Got a fleet of projects and teams? Let’s scale together! Contact us for custom pricing, massive discounts, and enterprise-grade solutions that fit like a glove.</div>
              <div style={styles.price}>$19.99</div>
            </div>
            <div style={styles.cta}>
            <button
              style={{ ...styles.btn, ...styles.btnBusiness }}
              onClick={() => handlePlanChoice("Contact Us")}
            >
              Contact Us
            </button>
          </div>
            <div style={styles.betaNote}>billed per person per month</div>
            <ul style={styles.features}>
              <li style={styles.feature}><span style={styles.check}>✓</span>Viewer</li>
              <li style={styles.feature}><span style={styles.check}>✓</span>Team Sharing</li>
              <li style={styles.feature}><span style={styles.check}>✓</span>Max Projects: Unlimited</li>
              <li style={styles.feature}><span style={styles.check}>✓</span>Max Users: Unlimited</li>
              <li style={styles.feature}><span style={styles.check}>✓</span>Schedule Analysis</li>
              <li style={styles.feature}><span style={styles.check}>✓</span>Templates Library</li>
              <li style={styles.feature}><span style={styles.check}>✓</span>Custom Support</li>
            </ul>
          </div>
          
        </div>
      </div>
    </div>
  );
}

export default Pricing;